import React from 'react';
import ContentLoader from 'react-content-loader';

import { times } from 'lodash';

import { Button } from 'components/v2';

interface ContentLoadingProps {
  classRoot: string;
  classButton: string;
}

const ContentLoading: React.FC<ContentLoadingProps> = ({ classRoot, classButton }) => (
  <div className={classRoot}>
    {times(3).map((n) => (
      <Button key={n} className={classButton} extraRounded disabled>
        <ContentLoader height={42} width={224}>
          <rect x="78" y="0" rx="0" ry="6" width="68" height="16" />
          <rect x="29" y="24" rx="0" ry="0" width="166" height="16" />
        </ContentLoader>
      </Button>
    ))}
  </div>
);

export default ContentLoading;
